// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unpivotCol {
    width: 20%;
}

.unpivotCB {
    text-align: center;
    align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/unpivot/unpivot.settings.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".unpivotCol {\n    width: 20%;\n}\n\n.unpivotCB {\n    text-align: center;\n    align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
